'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _BaseComponent2 = require('../base/BaseComponent');

var _BaseComponent3 = _interopRequireDefault(_BaseComponent2);

require('./index.scss');

var _ButtonClear = require('../button/ButtonClear');

var _ButtonClear2 = _interopRequireDefault(_ButtonClear);

var _Icon = require('../icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IDPassword = function (_BaseComponent) {
  (0, _inherits3.default)(IDPassword, _BaseComponent);

  function IDPassword(props) {
    (0, _classCallCheck3.default)(this, IDPassword);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IDPassword.__proto__ || (0, _getPrototypeOf2.default)(IDPassword)).call(this, props));

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly;

      if (disabled || readOnly) {
        return;
      }
      var value = event.target.value;
      _this.setValue(value);
    };

    _this.handleBlur = function () {
      var value = _this.getValue();
      _this.props.onBlur && _this.props.onBlur(value);
    };

    _this.onClear = function () {
      _this.setValue('');
    };

    _this.state = {
      isFocus: false,
      value: props.value || props.defaultValue,
      display: props.display
    };
    _this.dataTestID = 'password';
    _this.inputType = 'password';
    return _this;
  }

  (0, _createClass3.default)(IDPassword, [{
    key: 'onDisplay',
    value: function onDisplay() {
      this.setState({
        display: !this.state.display
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // if (!this.props.fromIDInput) {
      //   throw new Error(`Vui lòng sử dụng <IDInput type="${this.inputType}" />`);
      // }
      var _props = this.props,
          disabled = _props.disabled,
          className = _props.className,
          style = _props.style,
          isClearable = _props.isClearable,
          readOnly = _props.readOnly,
          autoComplete = _props.autoComplete;
      var value = this.state.value;

      return _react2.default.createElement(
        'div',
        {
          'data-testid': this.getDataTestId(),
          className: (0, _classnames2.default)('textbox body-wrap', className, { 'input-disabled': disabled, 'read-only': readOnly }),
          style: style
        },
        this.renderIcon('before'),
        _react2.default.createElement('input', {
          type: !this.state.display ? 'password' : 'text',
          className: 'text-input',
          ref: function ref(c) {
            _this2.ref = c;
          },
          placeholder: '',
          onChange: this.handleChange,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          disabled: disabled,
          value: value,
          style: {
            flex: 1,
            border: 0,
            padding: 10,
            height: '100%',
            outline: 0,
            background: 'transparent'
          },
          readOnly: readOnly,
          autoComplete: autoComplete
        }),
        _react2.default.createElement(
          'div',
          { style: {
              display: disabled ? 'none' : 'flex',
              alignItems: 'center',
              height: '100%'
            }
          },
          value && isClearable ? _react2.default.createElement(_ButtonClear2.default, { onClick: this.onClear }) : null,
          value && _react2.default.createElement(
            'div',
            {
              className: 'icon-field-visible-password',
              onClick: function onClick() {
                return _this2.onDisplay();
              },
              style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 20,
                marginRight: 5,
                fontSize: 15,
                cursor: 'pointer'
              }
            },
            _react2.default.createElement(_Icon2.default, { type: !this.state.display ? 'eye' : 'eye-invisible' })
          ),
          this.renderIcon('after'),
          this.renderPlaceholder()
        )
      );
    }
  }]);
  return IDPassword;
}(_BaseComponent3.default);

exports.default = IDPassword;


IDPassword.defaultProps = {
  iconCls: '',
  iconType: 'key',
  isClearable: true,
  visibleIcon: true,
  disabled: false,
  iconAlign: 'after',
  placeholder: 'Input...'
};